import { EventEmitter2 } from "eventemitter2";
import I from "immutable";
import { mergeMap } from "rxjs/operators";

import { actionCreators } from "../../actions";
import { createNewForumView } from "../../reducers/rooms";
import { getMonologUserId, getRoster, } from "../../reducers/roster";
import { is, orderedMapForEach } from "../../utils/immutable";
import { Epic } from "../../utils/types";
import { App } from "../App";

export class AccessStore extends EventEmitter2 {
    private _roomMemberIdsServer = I.Map<string, I.OrderedSet<string>>();
    private _roomMemberIds = I.Map<string, I.OrderedSet<string>>();

    get roomMemberIdsServer() { return this._roomMemberIdsServer; }
    public memberIds(roomId: string) {
        return this._roomMemberIds.get(roomId, I.OrderedSet<string>());
    }

    constructor (private app: App) {
        super({ maxListeners: 20 });
    }

    public epic: Epic = (action$) => action$.pipe(
        mergeMap((action) => {
            if (action.type === actionCreators.AddPrivateRoomMember.type) {
                const { roomId, userId } = action.payload;
                let memberIds = this._roomMemberIds.get(roomId, I.OrderedSet());
                memberIds = memberIds.add(userId);
                this._roomMemberIds = this._roomMemberIds.set(roomId, memberIds);
                this.emit("changed");
            }
            else if (action.type === actionCreators.RemovePrivateRoomMember.type) {
                const { roomId, userId } = action.payload;
                let memberIds = this._roomMemberIds.get(roomId, I.OrderedSet());
                memberIds = memberIds.delete(userId);
                this._roomMemberIds = this._roomMemberIds.set(roomId, memberIds);
                this.emit("changed");
            }
            else if (action.type === actionCreators.ToggleSettingAccess.type  || action.type === actionCreators.ToggleIsNewForumPrivate.type) {
                const { roomId } = "payload" in action ? action.payload : createNewForumView;
                const userId = getMonologUserId(this.app.rootStore.getState())
                const memberIds = this._roomMemberIds.get(roomId);
                if (!(memberIds && memberIds.size > 0)) {
                    this._roomMemberIds = this._roomMemberIds.set(roomId, I.OrderedSet(userId ? [userId] : []));
                }
                this.emit("changed");
            }
            else if (action.type === actionCreators.CreateForumSuccess.type) {
                const userId = getMonologUserId(this.app.rootStore.getState())
                this._roomMemberIds = this._roomMemberIds.set(createNewForumView.roomId, I.OrderedSet(userId ? [userId] : []));
                this.emit("changed");
            }
            else if (action.type === actionCreators.onRoster.type) {
                (action.payload.data.remove_room_ids || []).forEach((room_id) => {
                    this._roomMemberIdsServer = this._roomMemberIdsServer.delete(room_id);
                    this._roomMemberIds = this._roomMemberIds.delete(room_id);
                });

                const rootStore = this.app.rootStore.getState();
                const roster = getRoster(rootStore);

                orderedMapForEach(roster, (room) => {
                    if (room.forum_access && room.forum_access.full) {
                        let memberIds = I.OrderedSet<string>();
                        let isPrivate = true;

                        room.forum_access.full.forEach((accessItem) => {
                            if (accessItem === "everyone") {
                                isPrivate = false;
                            }
                            else if (accessItem.type === "user") {
                                memberIds = memberIds.add(accessItem.id);
                            }
                        });

                        const userId = getMonologUserId(this.app.rootStore.getState())
                        if (isPrivate && userId) {
                            memberIds = memberIds.add(userId);
                        }
                        const oldIds = this._roomMemberIdsServer.get(room.id, I.OrderedSet());
                        if (!is(memberIds, oldIds)) {
                            this._roomMemberIdsServer = this._roomMemberIdsServer.set(room.id, memberIds);
                            this._roomMemberIds = this._roomMemberIds.set(room.id, memberIds);
                        }
                    }
                });

                this.emit("changed");
            }
            return [];
        })
    )
}

